import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 24px 0;
  gap: 32px;
`

export const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: end;
  align-items: center;
`
